import { render, staticRenderFns } from "./DialogCreateComment.vue?vue&type=template&id=bc59e728&scoped=true"
import script from "./DialogCreateComment.vue?vue&type=script&lang=js"
export * from "./DialogCreateComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc59e728",
  null
  
)

export default component.exports